/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConstantLocalRain } from "./ConstantLocalRain";
import {
  ConstantLocalRainFromJSON,
  ConstantLocalRainFromJSONTyped,
  ConstantLocalRainToJSON,
  ConstantLocalRainToJSONTyped,
} from "./ConstantLocalRain";

/**
 *
 * @export
 * @interface PaginatedConstantLocalRainList
 */
export interface PaginatedConstantLocalRainList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<ConstantLocalRain>;
}

/**
 * Check if a given object implements the PaginatedConstantLocalRainList interface.
 */
export function instanceOfPaginatedConstantLocalRainList(
  value: object
): value is PaginatedConstantLocalRainList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedConstantLocalRainListFromJSON(json: any): PaginatedConstantLocalRainList {
  return PaginatedConstantLocalRainListFromJSONTyped(json, false);
}

export function PaginatedConstantLocalRainListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedConstantLocalRainList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(ConstantLocalRainFromJSON),
  };
}

export function PaginatedConstantLocalRainListToJSON(json: any): PaginatedConstantLocalRainList {
  return PaginatedConstantLocalRainListToJSONTyped(json, false);
}

export function PaginatedConstantLocalRainListToJSONTyped(
  value?: PaginatedConstantLocalRainList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ConstantLocalRainToJSON),
  };
}
